module.exports = __webpack_public_path__ + "img/egg-weight.c603fb8e.svg";